import styled from "styled-components";

export const HomePageContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 40px;
  margin-top: 4rem;
`;

export const UsernameHeading = styled.h2`
  color: #00103b;
  font-weight: 800;
  font-size: 30px;
`;
